// Portfolio data (images sourced via design_agent_full_stack from Unsplash / Pexels)

export const portfolioProjects = [
    {
        slug: "gongbi-magnolia",
        category: "mural",
        title: {
            en: "Gongbi Magnolia",
            tr: "Gongbi Manolyaları",
            nl: "Gongbi Magnolia",
        },
        image:
            "https://customer-assets.emergentagent.com/job_color-walls-2/artifacts/02rmxoi4_IMG_3792.webp",
        images: [
            "https://customer-assets.emergentagent.com/job_color-walls-2/artifacts/02rmxoi4_IMG_3792.webp",
            "https://customer-assets-39nsmqrw.emergentagent.net/job_color-walls-2/artifacts/hy13jsfb_IMG_3793.webp",
        ],
        location: {
            en: "Amsterdam, NL",
            tr: "Amsterdam, Hollanda",
            nl: "Amsterdam, NL",
        },
        surface: {
            en: "Exterior wall — porch",
            tr: "Dış duvar — veranda",
            nl: "Buitenmuur — veranda",
        },
        size: "90 × 170 cm",
        medium: {
            en: "Fine-brush acrylic on plaster",
            tr: "Sıva üzerine ince fırça akrilik",
            nl: "Fijnpenseel-acryl op pleisterwerk",
        },
        year: "2025",
        description: {
            en: "Drawing inspiration from the centuries-old Chinese Gongbi tradition, this mural celebrates the harmony of nature through delicate forms and intricate detail. Rather than reproducing the original artwork, the artist reimagines its essence, creating a contemporary interpretation that reflects a distinctive personal style.",
            tr: "Yüzlerce yıllık Çin Gongbi geleneğinden ilham alan bu mural, doğanın uyumunu narin formlar ve ince detaylarla kutluyor. Sanatçı, orijinal eseri yeniden üretmek yerine özünü yeniden hayal ediyor; kendine özgü kişisel üslubunu yansıtan çağdaş bir yorum yaratıyor.",
            nl: "Geïnspireerd op de eeuwenoude Chinese Gongbi-traditie viert deze muurschildering de harmonie van de natuur door verfijnde vormen en fijnzinnig detail. In plaats van het originele werk te reproduceren, herbedenkt de kunstenaar de essentie ervan en creëert een hedendaagse interpretatie die een geheel eigen persoonlijke stijl weerspiegelt.",
        },
    },
    {
        slug: "balcony-marsh",
        category: "mural",
        aspect: "aspect-[16/11]",
        title: {
            en: "Balcony Marsh",
            tr: "Balkondaki Sazlık",
            nl: "Balkonmoeras",
        },
        image:
            "https://customer-assets.emergentagent.com/job_color-walls-2/artifacts/20nl9n1q_IMG-20260626-WA0027.jpg",
        images: [
            "https://customer-assets.emergentagent.com/job_color-walls-2/artifacts/20nl9n1q_IMG-20260626-WA0027.jpg",
            "https://customer-assets-39nsmqrw.emergentagent.net/job_color-walls-2/artifacts/d70tobkq_IMG_3873.jpeg",
            "https://customer-assets-39nsmqrw.emergentagent.net/job_color-walls-2/artifacts/ofnjum8y_IMG_3874.jpeg",
        ],
        location: {
            en: "Antalya, Türkiye",
            tr: "Antalya, Türkiye",
            nl: "Antalya, Türkiye",
        },
        surface: {
            en: "Exterior balcony plaster",
            tr: "Dış balkon sıvası",
            nl: "Buitenbalkon pleisterwerk",
        },
        size: "50 × 75 cm & 80 × 75 cm",
        medium: {
            en: "Weather-resistant acrylic",
            tr: "Dış mekân akrilik",
            nl: "Weerbestendige acryl",
        },
        year: "2024",
        featured: false,
        description: {
            en: "A pair of hand-painted vignettes — a kingfisher with its catch on one wall, a tree frog among cattails and lotus blooms on the other — that turn a high-rise balcony into a quiet marshland. Painted directly onto the white plaster, the murals borrow their palette from the surrounding plants and soften the line between garden and wall.",
            tr: "Bir duvarda avını kıskıvrak yakalamış bir yalıçapkını, diğerinde sazlar ve lotuslar arasına tünemiş bir ağaç kurbağası — yüksek bir balkonu sessiz bir sazlığa dönüştüren el yapımı iki vinyet. Doğrudan beyaz sıvanın üzerine boyanmış muraller, paletini çevredeki bitkilerden ödünç alıyor; bahçeyle duvar arasındaki sınırı yumuşatıyor.",
            nl: "Twee handgeschilderde vignetten — een ijsvogel met zijn vangst op de ene muur, een boomkikker tussen lisdodden en lotusbloemen op de andere — die een hoogbouw-balkon in een stil moeras veranderen. Direct op het witte pleisterwerk geschilderd, lenen de muurschilderingen hun palet van de omringende planten en doen de grens tussen tuin en muur vervagen.",
        },
    },
    {
        slug: "watercolor-buddha",
        category: "mural",
        aspect: "aspect-[3/5]",
        title: {
            en: "Watercolor Buddha",
            tr: "Suluboya Buda",
            nl: "Aquarel Boeddha",
        },
        image:
            "https://customer-assets-39nsmqrw.emergentagent.net/job_color-walls-2/artifacts/2tbso1oj_B4A388C3-4FFE-4B50-8BA9-E08AA7D36D7C.PNG",
        images: [
            "https://customer-assets-39nsmqrw.emergentagent.net/job_color-walls-2/artifacts/2tbso1oj_B4A388C3-4FFE-4B50-8BA9-E08AA7D36D7C.PNG",
            "https://customer-assets-39nsmqrw.emergentagent.net/job_color-walls-2/artifacts/evh7w3nb_60DC4BC7-AF06-41FB-B06B-F9635DCD71C7.jpg",
        ],
        location: {
            en: "Amsterdam, NL",
            tr: "Amsterdam, Hollanda",
            nl: "Amsterdam, NL",
        },
        surface: {
            en: "Interior wall — hallway",
            tr: "İç duvar — koridor",
            nl: "Binnenmuur — hal",
        },
        size: "110 × 220 cm",
        medium: {
            en: "Ink & watercolor-effect acrylic on plaster",
            tr: "Sıva üzerine mürekkep ve suluboya etkili akrilik",
            nl: "Inkt & aquarel-effect acryl op pleisterwerk",
        },
        year: "2025",
        description: {
            en: "A tall, narrow hallway wall becomes a quiet altar: a serene Buddha head painted in soft ink washes, wrapped in a bloom of turquoise and rose-tinted lotus leaves that seem to breathe with him. The mural borrows the language of Chinese watercolor — bleeding pigment, uncontained edges, negative space as air — and turns a transitional corridor into a slow, meditative pause.",
            tr: "Uzun ve dar bir koridor duvarı sessiz bir sunağa dönüşüyor: yumuşak mürekkep akışlarıyla boyanmış huzurlu bir Buda başı, sanki onunla birlikte nefes alan turkuaz ve gül tonlu lotus yapraklarının arasında sarılı. Mural Çin suluboyasının dilini ödünç alıyor — dağılan pigment, sınırlanmamış kenarlar, hava olarak boşluk — ve bir geçiş koridorunu yavaş, meditatif bir duraklamaya çeviriyor.",
            nl: "Een lange, smalle gangmuur wordt een stil altaar: een sereen Boeddha-hoofd geschilderd in zachte inktwassingen, omhuld door een bloei van turkoois en roze-getinte lotusbladeren die met hem lijken te ademen. De muurschildering leent de taal van de Chinese aquarel — vloeiend pigment, ongebonden randen, negatieve ruimte als lucht — en verandert een doorloopcorridor in een langzame, meditatieve pauze.",
        },
    },
    {
        slug: "cobalt-reverie",
        category: "mural",
        featured: false,
        aspect: "aspect-[16/11]",
        title: {
            en: "Cobalt Reverie",
            tr: "Kobalt Düşü",
            nl: "Kobaltdroom",
        },
        image:
            "https://customer-assets.emergentagent.com/job_color-walls-2/artifacts/ady3uft6_IMG-20260626-WA0013.jpg",
        location: {
            en: "İstanbul, Cihangir",
            tr: "İstanbul, Cihangir",
            nl: "İstanbul, Cihangir",
        },
        surface: {
            en: "Interior plaster — feature wall",
            tr: "İç sıva — vurgu duvarı",
            nl: "Binnenpleisterwerk — accentmuur",
        },
        size: "210 × 260 cm",
        medium: {
            en: "Cobalt acrylic on plaster",
            tr: "Sıva üzerine kobalt akrilik",
            nl: "Kobaltacryl op pleisterwerk",
        },
        year: "2024",
        video: "/videos/cobalt-reverie-process.mp4",
        credit: {
            en: "Original artwork by Lorena Moreira",
            tr: "Orijinal eser: Lorena Moreira",
            nl: "Origineel werk door Lorena Moreira",
        },
        description: {
            en: "A site-specific cobalt-blue tableau painted directly onto raw plaster at the client's request — they chose this exact artwork by Lorena Moreira and asked for it to be reimagined at wall scale. A fluid nude figure balanced atop a spotted leopard, framed by sprawling tropical fronds. To settle the composition, I added the sweeping leaves in the lower-right corner — a small counterweight that brings the whole wall into balance. Matisse-inspired, gestural brushwork transforms a quiet interior wall into a high-contrast, almost Mediterranean focal point — single hue, single breath.",
            tr: "Müşterinin talebi üzerine doğrudan ham sıvanın üzerine boyanmış, mekâna özel bir kobalt mavisi tablo — Lorena Moreira'nın bu eserini bizzat seçtiler ve duvar ölçeğinde yeniden yorumlanmasını istediler. Benekli bir leoparın üzerinde dengelenen akışkan bir çıplak figür ve etrafını saran tropik palmiye yaprakları. Kompozisyonu oturtmak için sağ alt köşeye süpüren yaprakları ben ekledim — tüm duvarı dengeye kavuşturan küçük bir karşı ağırlık. Matisse esintili özgüvenli fırça darbeleri, sessiz bir iç duvarı yüksek kontrastlı, neredeyse Akdenizli bir odak noktasına dönüştürüyor — tek renk, tek nefes.",
            nl: "Een plekspecifiek tableau in kobaltblauw, op verzoek van de klant direct op ruw pleisterwerk geschilderd — zij kozen dit specifieke werk van Lorena Moreira en vroegen om het op muurschaal te herbedenken. Een vloeiende naaktfiguur in evenwicht bovenop een gespikkelde luipaard, omkaderd door uitwaaierende tropische varens. Om de compositie te vervolmaken heb ik in de rechteronderhoek de zwierige bladeren toegevoegd — een klein tegenwicht dat de hele muur in balans brengt. Door Matisse geïnspireerde, gebaarvolle penseelvoering verandert een stille binnenmuur in een hoogcontrast, bijna mediterraan brandpunt — één tint, één adem.",
        },
    },
    {
        slug: "balcony-jungle",
        category: "mural",
        featured: true,
        title: {
            en: "Balcony Jungle",
            tr: "Balkon Ormanı",
            nl: "Balkonjungle",
        },
        image:
            "https://customer-assets.emergentagent.com/job_color-walls-2/artifacts/udge82hf_IMG-20260626-WA0031.jpg",
        location: {
            en: "Adana, Türkiye",
            tr: "Adana, Türkiye",
            nl: "Adana, Türkiye",
        },
        surface: {
            en: "Exterior balcony wall",
            tr: "Dış balkon duvarı",
            nl: "Buitenbalkonmuur",
        },
        size: "210 × 260 cm",
        medium: {
            en: "Acrylic on textured plaster",
            tr: "Dokulu sıva üzerine akrilik",
            nl: "Acryl op gestructureerd pleisterwerk",
        },
        year: "2024",
        tag: {
            en: "Debut commission",
            tr: "İlk çalışma",
            nl: "Debuutopdracht",
        },
        description: {
            en: "This was my very first mural, and it all started with just two toucans. There was no full composition or plan in the beginning. As I painted, new ideas kept coming, and the mural gradually grew into a vibrant tropical scene with parrots, a sleeping leopard, lush foliage and exotic flowers. Looking back, this mural reflects the way I love to create — allowing each piece to evolve naturally until it tells a complete story.",
            tr: "Bu benim ilk muralımdı ve her şey sadece iki tukanla başladı. Başlangıçta ne tam bir kompozisyon vardı ne de bir plan. Boyadıkça yeni fikirler gelmeye devam etti; mural yavaş yavaş papağanların, uyuyan bir leoparın, gür yaprakların ve egzotik çiçeklerin yer aldığı canlı bir tropik sahneye dönüştü. Geriye dönüp baktığımda bu mural, benim yaratma biçimimi yansıtıyor — her esere, tam bir hikâye anlatana kadar doğal olarak evrilmesine izin vermeyi seviyorum.",
            nl: "Dit was mijn allereerste muurschildering, en het begon allemaal met slechts twee toekans. In het begin was er geen volledige compositie of plan. Terwijl ik schilderde bleven er nieuwe ideeën komen, en de muurschildering groeide geleidelijk uit tot een levendig tropisch tafereel met papegaaien, een slapende luipaard, weelderig gebladerte en exotische bloemen. Terugkijkend weerspiegelt deze muurschildering de manier waarop ik graag creëer — elk werk mag zich natuurlijk ontwikkelen totdat het een volledig verhaal vertelt.",
        },
    },
    {
        slug: "feathered-guardian",
        category: "canvas",
        title: {
            en: "Feathered Guardian",
            tr: "Tüylü Muhafız",
            nl: "Gevederde Beschermer",
        },
        image:
            "https://customer-assets.emergentagent.com/job_color-walls-2/artifacts/m95ciina_IMG_6114.webp",
        location: {
            en: "Studio, Amsterdam",
            tr: "Stüdyo, Amsterdam",
            nl: "Studio, Amsterdam",
        },
        surface: {
            en: "Canvas",
            tr: "Tuval",
            nl: "Doek",
        },
        size: "60 × 80 cm",
        medium: {
            en: "Oil & acrylic on canvas",
            tr: "Tuval üzerine yağlı boya ve akrilik",
            nl: "Olie & acryl op doek",
        },
        year: "2025",
        description: {
            en: "A ceremonial portrait crowned by a wide feathered headdress — pink, ivory and jet — over face paint drawn in slow, deliberate lines. The green and rose background swirls like wind, while the figure herself stays perfectly still: a small, quiet monument to strength.",
            tr: "Yavaş ve kararlı çizgilerle uygulanmış yüz boyasının üzerinde geniş bir tüy başlığıyla taçlandırılmış törensel bir portre — pembe, fildişi ve jet siyah. Yeşil ve gül tonlu arka plan rüzgâr gibi dönerken, figürün kendisi kıpırdamadan duruyor: sessiz, küçük bir güç anıtı.",
            nl: "Een ceremonieel portret gekroond door een brede verentooi — roze, ivoor en git — boven gezichtsbeschildering in trage, doelbewuste lijnen. De groen-roze achtergrond wervelt als wind, terwijl de figuur zelf volkomen stil blijft: een klein, stil monument voor kracht.",
        },
    },
    {
        slug: "portrait-under-parasol",
        category: "canvas",
        title: {
            en: "Under the Parasol",
            tr: "Şemsiyenin Altında",
            nl: "Onder de Parasol",
        },
        image:
            "https://customer-assets.emergentagent.com/job_color-walls-2/artifacts/uv03ved8_D56DC47C-1CCF-4897-A60C-7BD20E54B2EA.webp",
        location: {
            en: "Studio, Amsterdam",
            tr: "Stüdyo, Amsterdam",
            nl: "Studio, Amsterdam",
        },
        surface: {
            en: "Canvas",
            tr: "Tuval",
            nl: "Doek",
        },
        size: "40 × 60 cm",
        medium: {
            en: "Oil on canvas",
            tr: "Tuval üzerine yağlı boya",
            nl: "Olie op doek",
        },
        year: "2025",
        description: {
            en: "A warm-hearted portrait painted from memory — a smiling woman beneath a soft parasol, dressed in a floral blouse. Painted in loose, impressionist brushwork, the piece holds onto a small, everyday moment of joy.",
            tr: "Anıdan boyanmış sıcak kalpli bir portre — yumuşak bir şemsiyenin altında, çiçekli bir bluz giyen gülümseyen bir kadın. Gevşek, empresyonist fırça darbeleriyle yapılan eser, gündelik küçük bir mutluluk anını sıkıca tutuyor.",
            nl: "Een warmhartig portret geschilderd uit het geheugen — een glimlachende vrouw onder een zachte parasol, gekleed in een bloemenblouse. In losse, impressionistische penseelvoering geschilderd houdt het werk een klein, alledaags moment van vreugde vast.",
        },
    },
    {
        slug: "portrait-of-my-sister",
        category: "canvas",
        title: {
            en: "Portrait of My Sister",
            tr: "Kız Kardeşimin Portresi",
            nl: "Portret van Mijn Zus",
        },
        image:
            "https://customer-assets.emergentagent.com/job_color-walls-2/artifacts/qjxlxygq_IMG_6425.jpg",
        location: {
            en: "Studio, Amsterdam",
            tr: "Stüdyo, Amsterdam",
            nl: "Studio, Amsterdam",
        },
        surface: {
            en: "Canvas",
            tr: "Tuval",
            nl: "Doek",
        },
        size: "80 × 80 cm",
        medium: {
            en: "Acrylic on canvas",
            tr: "Tuval üzerine akrilik",
            nl: "Acryl op doek",
        },
        year: "2025",
        description: {
            en: "A tender portrait of the artist's sister — her burgundy hair caught mid-motion, her smile quiet and knowing. She sits inside a storm of pastel splashes: cream, cobalt, ochre and coral drifting across the canvas like light through water. Half likeness, half feeling — a love letter painted in loose, fluid brushwork.",
            tr: "Sanatçının kız kardeşinin sıcak bir portresi — bordo saçları hareket halinde yakalanmış, gülümsemesi sessiz ve bilge. Krem, kobalt, oker ve mercan tonlarındaki pastel sıçramaların oluşturduğu bir fırtınanın içinde oturuyor; sanki suyun içinden süzülen ışık gibi tuvale yayılan renkler. Yarı benzerlik, yarı duygu — gevşek, akıcı fırça darbeleriyle yazılmış bir aşk mektubu.",
            nl: "Een teder portret van de zus van de kunstenaar — haar bordeauxrode haar gevangen in beweging, haar glimlach stil en veelzeggend. Ze zit binnenin een storm van pastelspatten: crème, kobalt, oker en koraal drijven over het doek als licht door water. Half gelijkenis, half gevoel — een liefdesbrief geschilderd in losse, vloeiende penseelvoering.",
        },
    },
    {
        slug: "cobalt-splinter",
        category: "canvas",
        aspect: "aspect-[3/4]",
        title: {
            en: "Cobalt Splinter",
            tr: "Kobalt Kırığı",
            nl: "Kobaltsplinter",
        },
        image: "/portfolio-crops/cobalt-splinter.jpg",
        location: {
            en: "Studio, Amsterdam",
            tr: "Stüdyo, Amsterdam",
            nl: "Studio, Amsterdam",
        },
        surface: {
            en: "Canvas",
            tr: "Tuval",
            nl: "Doek",
        },
        size: "50 × 70 cm",
        medium: {
            en: "Acrylic on canvas",
            tr: "Tuval üzerine akrilik",
            nl: "Acryl op doek",
        },
        year: "2024",
        description: {
            en: "An abstract eruption in the three colours of the Dutch flag — cobalt, crimson and pure white — scraped, dragged and left mid-gesture. Painted in Amsterdam as a quiet homage to a new home: no figure, no horizon, just the flag distilled into raw brushwork and drip, a landscape after rain that never quite settles.",
            tr: "Hollanda bayrağının üç renginde — kobalt, krimson ve saf beyaz — soyut bir patlama; boya kazınmış, sürüklenmiş ve hareketin ortasında bırakılmış. Yeni bir yurda sessiz bir selam olarak Amsterdam'da boyandı: figür yok, ufuk yok — yalnızca ham fırça darbelerine ve damlalara indirgenmiş bir bayrak, yağmur sonrası hiç yatışmayan bir manzara.",
            nl: "Een abstracte uitbarsting in de drie kleuren van de Nederlandse vlag — kobalt, karmijn en zuiver wit — geschraapt, gesleept en midden in het gebaar achtergelaten. Geschilderd in Amsterdam als een stille eerbetoon aan een nieuw thuis: geen figuur, geen horizon, alleen de vlag teruggebracht tot rauwe penseelstreken en druppels, een landschap na de regen dat zich nooit helemaal legt.",
        },
    },
    {
        slug: "tidewater",
        category: "canvas",
        title: {
            en: "Tidewater",
            tr: "Gelgit Suyu",
            nl: "Getijdenwater",
        },
        image:
            "https://customer-assets.emergentagent.com/job_color-walls-2/artifacts/w6vls6f8_B76CAA5A-EC0E-4D52-A5B5-BAD297C0F1A0.webp",
        location: {
            en: "Studio, Amsterdam",
            tr: "Stüdyo, Amsterdam",
            nl: "Studio, Amsterdam",
        },
        surface: {
            en: "Canvas",
            tr: "Tuval",
            nl: "Doek",
        },
        size: "60 × 90 cm",
        medium: {
            en: "Oil on canvas",
            tr: "Tuval üzerine yağlı boya",
            nl: "Olie op doek",
        },
        year: "2025",
        description: {
            en: "A quiet abstract in turquoise and moss, split by a rusted horizon and streaks of yellow like reeds catching the sun. Half seascape, half memory of one — painted in patient, wet-on-wet layers.",
            tr: "Turkuaz ve yosun yeşilinde sessiz bir soyut; paslı bir ufuk ve güneşi yakalayan sazlar gibi sarı çizgilerle bölünmüş. Yarı deniz manzarası, yarı onun anısı — sabırla, ıslak-üstüne-ıslak katmanlarla boyandı.",
            nl: "Een stille abstractie in turkoois en mos, doorsneden door een roestige horizon en gele strepen als riet dat de zon vangt. Half zeegezicht, half herinnering eraan — geduldig in nat-in-nat lagen geschilderd.",
        },
    },
    {
        slug: "cave-marks-bird",
        category: "canvas",
        series: "Cave Marks",
        title: {
            en: "Cave Marks I — Bird",
            tr: "Mağara İzleri I — Kuş",
            nl: "Grotmarkeringen I — Vogel",
        },
        image:
            "https://customer-assets.emergentagent.com/job_color-walls-2/artifacts/0mdomvx5_IMG_6344.webp",
        location: {
            en: "Studio, Amsterdam",
            tr: "Stüdyo, Amsterdam",
            nl: "Studio, Amsterdam",
        },
        surface: {
            en: "Canvas",
            tr: "Tuval",
            nl: "Doek",
        },
        size: "70 × 50 cm",
        medium: {
            en: "Oil on canvas — ochre & iron red",
            tr: "Tuval üzerine yağlı boya — oker ve demir kırmızısı",
            nl: "Olie op doek — oker & ijzerrood",
        },
        year: "2025",
        tag: {
            en: "Cave Marks — Diptych I / II",
            tr: "Mağara İzleri — Diptik I / II",
            nl: "Grotmarkeringen — Diptiek I / II",
        },
        description: {
            en: "Cave Marks is a small diptych painted like a message left on rock: iron-red and ochre figures rising out of a warm, weathered ground. The first panel holds a wounded bird, its body opened by a red stroke that reads as both feather and arrow; the second gathers a heavy bison and a fleeing stag in mid-leap. Together they read as one thought about survival — hunter and hunted, movement and stillness, memory pressed into a wall that has already begun to forget.",
            tr: "Mağara İzleri, kayaya bırakılmış bir mesaj gibi boyanmış küçük bir diptiktir: sıcak, yıpranmış bir zeminden yükselen demir kırmızısı ve oker figürler. İlk panelde bedeni hem tüy hem ok gibi okunan kırmızı bir darbeyle açılmış yaralı bir kuş var; ikincisi ağır bir bizonu ve sıçrayışın ortasında kaçan bir geyiği bir araya getiriyor. İkisi birlikte hayatta kalma üzerine tek bir düşünce olarak okunuyor — avcı ve av, hareket ve durgunluk, unutmaya çoktan başlamış bir duvara bastırılmış hafıza.",
            nl: "Grotmarkeringen is een klein diptiek geschilderd als een boodschap achtergelaten op steen: ijzerrode en okerkleurige figuren die oprijzen uit een warme, verweerde ondergrond. Het eerste paneel toont een gewonde vogel, zijn lichaam opengelegd door een rode streek die zowel veer als pijl is; het tweede brengt een zware bizon samen met een vluchtend hert midden in de sprong. Samen lezen ze als één gedachte over overleven — jager en prooi, beweging en stilte, herinnering geperst in een muur die al begonnen is te vergeten.",
        },
    },
    {
        slug: "cave-marks-bison",
        category: "canvas",
        series: "Cave Marks",
        aspect: "aspect-[16/11]",
        fit: "contain",
        title: {
            en: "Cave Marks II — Bison & Stag",
            tr: "Mağara İzleri II — Bizon ve Geyik",
            nl: "Grotmarkeringen II — Bizon & Hert",
        },
        image:
            "https://customer-assets.emergentagent.com/job_color-walls-2/artifacts/x9pg6hbg_IMG_6345.webp",
        location: {
            en: "Studio, Amsterdam",
            tr: "Stüdyo, Amsterdam",
            nl: "Studio, Amsterdam",
        },
        surface: {
            en: "Canvas",
            tr: "Tuval",
            nl: "Doek",
        },
        size: "70 × 50 cm",
        medium: {
            en: "Oil on canvas — ochre & iron red",
            tr: "Tuval üzerine yağlı boya — oker ve demir kırmızısı",
            nl: "Olie op doek — oker & ijzerrood",
        },
        year: "2025",
        tag: {
            en: "Cave Marks — Diptych II / II",
            tr: "Mağara İzleri — Diptik II / II",
            nl: "Grotmarkeringen — Diptiek II / II",
        },
        description: {
            en: "Cave Marks is a small diptych painted like a message left on rock: iron-red and ochre figures rising out of a warm, weathered ground. The first panel holds a wounded bird, its body opened by a red stroke that reads as both feather and arrow; the second gathers a heavy bison and a fleeing stag in mid-leap. Together they read as one thought about survival — hunter and hunted, movement and stillness, memory pressed into a wall that has already begun to forget.",
            tr: "Mağara İzleri, kayaya bırakılmış bir mesaj gibi boyanmış küçük bir diptiktir: sıcak, yıpranmış bir zeminden yükselen demir kırmızısı ve oker figürler. İlk panelde bedeni hem tüy hem ok gibi okunan kırmızı bir darbeyle açılmış yaralı bir kuş var; ikincisi ağır bir bizonu ve sıçrayışın ortasında kaçan bir geyiği bir araya getiriyor. İkisi birlikte hayatta kalma üzerine tek bir düşünce olarak okunuyor — avcı ve av, hareket ve durgunluk, unutmaya çoktan başlamış bir duvara bastırılmış hafıza.",
            nl: "Grotmarkeringen is een klein diptiek geschilderd als een boodschap achtergelaten op steen: ijzerrode en okerkleurige figuren die oprijzen uit een warme, verweerde ondergrond. Het eerste paneel toont een gewonde vogel, zijn lichaam opengelegd door een rode streek die zowel veer als pijl is; het tweede brengt een zware bizon samen met een vluchtend hert midden in de sprong. Samen lezen ze als één gedachte over overleven — jager en prooi, beweging en stilte, herinnering geperst in een muur die al begonnen is te vergeten.",
        },
    },
    {
        slug: "portrait-in-cobalt-crimson",
        category: "canvas",
        title: {
            en: "Portrait in Cobalt & Crimson",
            tr: "Kobalt ve Krimson Portre",
            nl: "Portret in Kobalt & Karmijn",
        },
        image:
            "https://customer-assets.emergentagent.com/job_color-walls-2/artifacts/yajjel1j_5B1FADBF-92DE-4D33-AD6D-BAD1AFA83B30.JPG",
        location: {
            en: "Studio, Amsterdam",
            tr: "Stüdyo, Amsterdam",
            nl: "Studio, Amsterdam",
        },
        surface: {
            en: "Canvas",
            tr: "Tuval",
            nl: "Doek",
        },
        size: "70 × 90 cm",
        medium: {
            en: "Oil & acrylic on canvas",
            tr: "Tuval üzerine yağlı boya ve akrilik",
            nl: "Olie & acryl op doek",
        },
        year: "2024",
        description: {
            en: "A brooding male portrait carved out of cobalt, crimson and peach. The face turns slightly downward — eyes lowered, jaw set — while the surrounding field breaks into torn, painterly strokes. A study of quiet interior weight.",
            tr: "Kobalt, krimson ve şeftali tonlarından oyulmuş, düşünceli bir erkek portresi. Yüz hafifçe aşağıya dönüyor — göz kapakları düşük, çene sıkı — çevresindeki alan ise parçalı, ressamca fırça darbeleriyle kırılıyor. Sessiz bir iç ağırlığın etüdü.",
            nl: "Een broedend mannenportret uitgesneden uit kobalt, karmijn en perzik. Het gezicht draait licht naar beneden — de ogen gesloten, de kaak strak — terwijl het omringende veld openbreekt in gescheurde, schilderachtige toetsen. Een studie van stil innerlijk gewicht.",
        },
    },
    {
        slug: "two-white-butterflies",
        category: "canvas",
        title: {
            en: "Two White Butterflies",
            tr: "İki Beyaz Kelebek",
            nl: "Twee Witte Vlinders",
        },
        image:
            "https://customer-assets.emergentagent.com/job_color-walls-2/artifacts/zk9xfgh6_IMG_6373.webp",
        location: {
            en: "Studio, Amsterdam",
            tr: "Stüdyo, Amsterdam",
            nl: "Studio, Amsterdam",
        },
        surface: {
            en: "Canvas",
            tr: "Tuval",
            nl: "Doek",
        },
        size: "60 × 80 cm",
        medium: {
            en: "Acrylic on canvas",
            tr: "Tuval üzerine akrilik",
            nl: "Acryl op doek",
        },
        year: "2025",
        description: {
            en: "Painted for a dear friend who chose the subject — two white butterflies drifting across a deep, cobalt sky. On the left, a pale plume of blossoms rises like breath through the blue; on the right, the two ghostly butterflies lift into the light as though carrying a wish upward. Quiet, personal, and made as a gift.",
            tr: "Konusunu bir dostun seçtiği, ona hediye olarak yapılmış bir eser — derin kobalt bir gökyüzünde süzülen iki beyaz kelebek. Solda, mavinin içinden bir nefes gibi yükselen soluk bir çiçek dalı; sağda, sanki bir dileği yukarı taşıyormuşçasına ışığa doğru kalkan iki hayaletsi kelebek. Sessiz, kişisel ve armağan olarak yapılmış.",
            nl: "Geschilderd voor een dierbare vriend die het onderwerp koos — twee witte vlinders die over een diepe, kobaltblauwe hemel drijven. Links stijgt een bleke pluim van bloesems als een adem door het blauw; rechts stijgen de twee spookachtige vlinders naar het licht, alsof ze een wens omhoog dragen. Stil, persoonlijk, en gemaakt als geschenk.",
        },
    },
    {
        slug: "year-of-the-dragon",
        category: "canvas",
        aspect: "aspect-square",
        title: {
            en: "Year of the Dragon",
            tr: "Ejder Yılı",
            nl: "Jaar van de Draak",
        },
        image:
            "https://customer-assets.emergentagent.com/job_color-walls-2/artifacts/c5vmy7gz_IMG_2685%202.jpg",
        location: {
            en: "Studio, Amsterdam",
            tr: "Stüdyo, Amsterdam",
            nl: "Studio, Amsterdam",
        },
        surface: {
            en: "Canvas",
            tr: "Tuval",
            nl: "Doek",
        },
        size: "60 × 60 cm",
        medium: {
            en: "Acrylic on canvas",
            tr: "Tuval üzerine akrilik",
            nl: "Acryl op doek",
        },
        year: "2024",
        description: {
            en: "Painted in 2024 — the Chinese Year of the Dragon — this crimson tondo winds a single dragon through swirling clouds and pearl-scaled coils. Rendered in fine, near-monochrome brushwork on a red-lacquer ground, it borrows the language of Ming-dynasty ceramics and translates it into a personal talisman: strength, luck and quiet fire, held inside one perfect circle.",
            tr: "2024'te — Çin takviminde Ejder Yılı'nda — boyanmış bu krimson tondo, tek bir ejderi kıvrılan bulutlar ve inci pullu halkalar arasında dolandırıyor. Kırmızı lake bir zemin üzerine ince, neredeyse tek-renkli fırça darbeleriyle işlenmiş; Ming hanedanı seramiklerinin dilinden ödünç alınarak kişisel bir tılsıma dönüştürülmüş: güç, şans ve kusursuz bir dairenin içinde tutulan sessiz ateş.",
            nl: "Geschilderd in 2024 — het Chinese Jaar van de Draak — leidt dit karmijnrode tondo één enkele draak door wervelende wolken en parelmoerkleurige spiralen. Uitgevoerd in fijn, bijna monochroom penseelwerk op een rood lakachtige ondergrond, ontleent het de taal van Ming-keramiek en vertaalt die naar een persoonlijk talisman: kracht, geluk en stil vuur, gevat binnen één perfecte cirkel.",
        },
    },
    {
        slug: "two-boats-craig-penny",
        category: "canvas",
        aspect: "aspect-[4/3]",
        title: {
            en: "Two Boats at Low Tide",
            tr: "Alçalan Suda İki Kayık",
            nl: "Twee Boten bij Laag Water",
        },
        image:
            "https://customer-assets-39nsmqrw.emergentagent.net/job_color-walls-2/artifacts/lwzb0twl_IMG_5724.webp",
        images: [
            "https://customer-assets-39nsmqrw.emergentagent.net/job_color-walls-2/artifacts/lwzb0twl_IMG_5724.webp",
            "https://customer-assets-39nsmqrw.emergentagent.net/job_color-walls-2/artifacts/y82ftoud_IMG_3882.webp",
            "https://customer-assets-39nsmqrw.emergentagent.net/job_color-walls-2/artifacts/6yf8cf2v_IMG_2501.jpg",
        ],
        location: {
            en: "Studio, Amsterdam",
            tr: "Stüdyo, Amsterdam",
            nl: "Studio, Amsterdam",
        },
        surface: {
            en: "Canvas (framed)",
            tr: "Tuval (çerçeveli)",
            nl: "Doek (ingelijst)",
        },
        size: "24 × 18 cm",
        medium: {
            en: "Oil on canvas",
            tr: "Tuval üzerine yağlı boya",
            nl: "Olie op doek",
        },
        year: "2024",
        tag: {
            en: "Craig Penny workshop study",
            tr: "Craig Penny atölye çalışması",
            nl: "Craig Penny workshop-studie",
        },
        credit: {
            en: "Painted during a workshop with Australia's beloved artist Craig Penny.",
            tr: "Avustralya'nın sevilen sanatçısı Craig Penny'nin atölyesinde yapıldı.",
            nl: "Geschilderd tijdens een workshop bij Australië's geliefde kunstenaar Craig Penny.",
        },
        description: {
            en: "A small oil study made during a workshop with Australia's beloved seascape painter Craig Penny — two wooden dinghies resting at low tide while three gulls trace the shoreline. The exercise focused on his signature: patient blues layered wet-into-wet, high-key sand, and the light-carrying whites that hold the whole picture together.",
            tr: "Avustralya'nın sevilen deniz manzarası ressamı Craig Penny'nin atölyesinde yapılmış küçük bir yağlı boya etüdü — alçalan suda dinlenen iki ahşap kayık ve kıyıyı takip eden üç martı. Çalışma onun imza tekniğine odaklandı: sabırla ıslak-üstüne-ıslak katlanmış maviler, aydınlık kumsal ve tüm resmi bir arada tutan ışık taşıyan beyazlar.",
            nl: "Een kleine olieverfstudie gemaakt tijdens een workshop bij Australië's geliefde zeegezichtschilder Craig Penny — twee houten sloepen die rusten bij laag tij terwijl drie meeuwen de kustlijn volgen. De oefening richtte zich op zijn kenmerkende stijl: geduldige blauwen nat-in-nat gelaagd, licht zand en de lichtdragende witten die het hele beeld samenhouden.",
        },
    },
];

export const heroImage =
    "https://customer-assets.emergentagent.com/job_color-walls-2/artifacts/tjoims9j_IMG-20260626-WA0038.jpg";

export const aboutImage =
    "https://customer-assets.emergentagent.com/job_color-walls-2/artifacts/hb45pubw_IMG-20260703-WA0013.jpg";

export const contactImage =
    "https://customer-assets.emergentagent.com/job_color-walls-2/artifacts/33d7fsss_IMG-20260626-WA0039.jpg";

export const studioContact = {
    email: "hello@ahmetsaskin.studio",
    whatsapp: "+31 6 132 278 267",
    whatsappLink: "https://wa.me/316132278267",
    instagram: "@ahmetography",
    instagramLink: "https://instagram.com/ahmetography",
    city: {
        en: "Amsterdam, NL",
        tr: "Amsterdam, Hollanda",
        nl: "Amsterdam, NL",
    },
};
